import { useMemo, useState } from "react";
import { topicItems } from "@/mocks/profile";

const filters = ["全部", "近况", "绯闻", "个人资料", "社交动态"];

const heatStyle: Record<string, string> = {
  高: "bg-primary-100 text-primary-700 border-primary-200",
  中: "bg-secondary-100 text-secondary-800 border-secondary-200",
};

export default function TopicSection() {
  const [active, setActive] = useState("全部");

  const list = useMemo(() => {
    if (active === "全部") return topicItems;
    return topicItems.filter((t) => t.tag === active);
  }, [active]);

  return (
    <section id="topics" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mb-8">
          <p className="font-label text-primary-600 text-xs tracking-[0.25em] mb-3">TOPICS / 八卦</p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-4">
            网络热议话题逐个拆
          </h2>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
            每条话题都写清了「讨论从哪来、可靠性大概如何」。点击下方标签可以只看某一类，筛选只作用于本页已有的内容，不会跳转或加载新数据。
          </p>
        </div>

        <div className="flex flex-wrap gap-2 mb-8" role="tablist" aria-label="话题分类筛选">
          {filters.map((f) => {
            const isActive = active === f;
            const count =
              f === "全部" ? topicItems.length : topicItems.filter((t) => t.tag === f).length;
            return (
              <button
                key={f}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => setActive(f)}
                className={`px-1 py-1 rounded-full border transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? "bg-primary-500 border-primary-500 text-background-50"
                    : "bg-background-100 border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                <span className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-label">
                  {f}
                  <span
                    className={`text-[11px] ${
                      isActive ? "text-background-100" : "text-foreground-500"
                    }`}
                  >
                    {count}
                  </span>
                </span>
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {list.map((t) => (
            <article
              key={t.title}
              className="flex flex-col bg-background-100 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center justify-between gap-3 mb-3">
                <span className="font-label text-[11px] text-secondary-800 bg-secondary-100 px-2.5 py-1 rounded-full">
                  {t.tag}
                </span>
                <span
                  className={`font-label text-[11px] px-2.5 py-1 rounded-full border ${heatStyle[t.heat] ?? heatStyle["中"]}`}
                >
                  讨论热度 {t.heat}
                </span>
              </div>
              <h3 className="font-heading font-bold text-foreground-950 text-lg leading-snug mb-2.5">
                {t.title}
              </h3>
              <p className="text-foreground-700 text-sm leading-relaxed flex-1">{t.summary}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}